import React, { useState } from 'react';
import BeneficiaryAdultValues, {
  BeneficiaryAgeProps
} from './BeneficiaryAdultValues';
import BorderedButton from '../BorderedButton';

const minWidth = 256;

const BeneficiaryAdults: React.FC<BeneficiaryAgeProps> = ({
  beneficiary,
  setBeneficiaries
}) => {
  const [open, setOpen] = useState<boolean>(
    beneficiary?.categories.findIndex(x => x.name === 'Adults') !== -1 ||
      beneficiary?.categories.findIndex(
        x => x.name === 'Nineteen and older'
      ) !== -1 ||
      beneficiary?.categories.findIndex(x => x.name === 'Seniors') !== -1
  );
  const handleOpen = () => setOpen(true);
  if (!open)
    return (
      <BorderedButton minWidth={minWidth} text="Adults" onClick={handleOpen} />
    );
  return (
    <BeneficiaryAdultValues
      beneficiary={beneficiary}
      setBeneficiaries={setBeneficiaries}
    />
  );
};

export default BeneficiaryAdults;
